// pages/BacklogPage.jsx
import React, { useState, useEffect, useCallback, useRef, use } from 'react';
import SprintListSection from '../../taskManagement/BackLogPage/SprintListSection';
import {
  Typography,
  Input,
  Select,
  Avatar,
  message,
  Tooltip,
  Space,
  Menu,
  Dropdown,
} from 'antd';
import {
  DndContext,
  closestCenter,
  useDroppable,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable';
import { AiOutlineSearch } from 'react-icons/ai';
import { Card } from 'reactstrap';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { setProjectName } from 'store/actions';
import { BulletList } from 'react-content-loader';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {
  setsprintdata,
  setassigneelist,
  setbacklogdata,
  setEpiclist,
  setlabellist,
} from 'store/actions';
import { useFetchBacklogData } from 'views/admin/taskManagement/BackLogPage/Alldata';
import UserAvatar from '../../../../components/userAvatar/index';
import TaskDetailPanel from '../BackLogPage/TaskSidePanel';
import '../pages/BacklogPage.css';
import Split from 'react-split';
import SubtaskDetailModal from '../BackLogPage/SubtaskDetailModal';
import { get } from 'store';
import SkeletonWithLoaders from 'components/common/Spinner';
import { Flex } from '@chakra-ui/react';
import Backlog from '../BackLogPage/Backlog';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';

dayjs.extend(utc);
const { Option } = Select;

const DroppableContainer = ({ id, children }) => {
  const { setNodeRef } = useDroppable({
    id,
    data: {
      type: 'container',
    },
  });

  return <div ref={setNodeRef}>{children}</div>;
};

const BacklogPage = () => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [backlogTasks, setBacklogTasks] = useState([]);
  const [sprintTasks, setSprintTasks] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  //const [searchTerm, setSearchTerm] = useState('');
  const [selectedEpic, setSelectedEpic] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState([]);
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [selectedIssueTypeId, setSelectedIssueTypeId] = useState([]);

  //const [labelOptions, setLabelOptions] = useState([]);
  const [tasks, set] = useState([]);

  const [filteredBacklogTasks, setFilteredBacklogTasks] = useState([]);
  const [filteredSprintTasks, setFilteredSprintTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [isSubtaskModalOpen, setIsSubtaskModalOpen] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [subTasks, setSubTasks] = useState([]);
  const [subtaskDetails, setSubtaskDetails] = useState(null);

  const [selectedSprintKeys, setSelectedSprintKeys] = useState([]);
  const [sprintList, setSprintList] = useState([]);
  const [sprintBacklogList, setSprintBacklogList] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  const dispatch = useDispatch();
  const { id } = useParams();
  const projectId = Number(id);
  const dropdownRef = useRef(null);

  const assigneeOptions = useSelector(
    (state) => state.Authentication?.assigneelist,
  );

  const epicOptions = useSelector((state) => state.Authentication?.Epiclist);
  //{console.log({epicOptions})}

  const labelOptions = useSelector((state) => state.Authentication?.labellist);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
  );

  const {
    fetchBacklogData,
    filterTask,
    displayedSprints,
    displayedBacklog,
    searchTerm,
    setSearchTerm,
    sprints,
    setSprints,
    backlogData,
    setBacklogData,
    isFiltering,
    setIsFiltering,
    setFilteredBacklog,
    setFilteredSprints,
    backlogCounts,
    sprintCounts,
    transformedBacklog,
  } = useFetchBacklogData(
    projectId,
    assigneeOptions,
    epicOptions,
    labelOptions,
  );

  const MAX_VISIBLE = 4;

  // const handleDragEnd = (event) => {
  //   const { active, over } = event;
  //   if (!over) return;
  // };

  const hasFilters = (filters) => {
    return Object.values(filters).some((val) =>
      Array.isArray(val) ? val.length > 0 : !!val,
    );
  };

  const fetchUsers = async () => {
    try {
      const assigneeRes =
        await httpInjectorService.getProjectAssigneeList(projectId);
      if (
        assigneeRes?.status === 'success' &&
        Array.isArray(assigneeRes.data)
      ) {
        //setAssigneeOptions(assigneeRes.data);
        dispatch(setassigneelist(assigneeRes.data));
        const initialTasks = [];
        assigneeRes.data.forEach((a) => {
          initialTasks[a.assignee_id] = [];
        });
        set(initialTasks);
        // setUsers(assigneeRes.data);
      } else {
        //setAssigneeOptions([]);
        dispatch(setassigneelist([]));
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      //setAssigneeOptions([]);
      dispatch(setassigneelist([]));
    }
  };

  const fetchMetadata = async (projectId) => {
    try {
      const [assigneeRes, epicRes, statusRes, labelRes] = await Promise.all([
        httpInjectorService.getProjectAssigneeList(projectId),
        httpInjectorService.getEpicList(projectId),
        httpInjectorService.ListBoardStatus(projectId),
        httpInjectorService.getLabelList(projectId),
      ]);

      //  Assignee
      if (
        assigneeRes?.status === 'success' &&
        Array.isArray(assigneeRes.data)
      ) {
        //setAssigneeOptions(assigneeRes.data);
        dispatch(setassigneelist(assigneeRes.data));
      } else {
        //setAssigneeOptions([]);
        dispatch(setassigneelist([]));
      }

      //  Epics
      if (epicRes?.status === 'success' && Array.isArray(epicRes.data)) {
        //setEpicOptions(epicRes.data);
        dispatch(setEpiclist(epicRes.data));
      } else {
        //setEpicOptions([]);
        dispatch(setEpiclist([]));
      }

      //  Statuses
      if (statusRes?.status === 'success' && Array.isArray(statusRes.data)) {
        setStatusOptions(statusRes.data);
        const initialTasks = {};
        statusRes.data.forEach((s) => {
          initialTasks[s.status_name] = [];
        });
        set(initialTasks);
      } else {
        setStatusOptions([]);
      }

      //Labels
      if (labelRes?.status === 'success' && Array.isArray(labelRes.data)) {
        // setLabelOptions(labelRes.data);
        dispatch(setlabellist(labelRes.data));
        const labelIds = labelRes.data.map((label) => label.label_id);
      } else {
        //setLabelOptions([]);
        dispatch(setlabellist([]));
      }
    } catch (error) {
      console.error('Error fetching board data:', error);
      //setAssigneeOptions([]);
      //setEpicOptions([]);
      setStatusOptions([]);
      //setLabelOptions([]);
      dispatch(setassigneelist([]));
      dispatch(setEpiclist([]));
      dispatch(setlabellist([]));
    }
  };

  const fetchSubtaskData = async () => {
    let reqbody = {
      project_id: projectId,
      issue_id: selectedTask.id,
    };
    try {
      const response = await httpInjectorService.getsubtaskList(reqbody);
      //console.log('response data subtask', response);
      setSubTasks(response.data);
    } catch (error) {
      console.error('Error fetching subtasks:', error);
    }
  };

  const getSubTaskDetails = async () => {
    const queryParams = `?subtask_id=${selectedSubtask?.subtask_id}&project_id=${projectId}`;
    try {
      const response = await httpInjectorService.getSubtaskById(queryParams);
      //console.log(response, 'response subtask by id');
      setSubtaskDetails(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    if (selectedSubtask) {
      getSubTaskDetails();
    }
  }, [selectedSubtask]);

  useEffect(() => {
    if (selectedTask) {
      fetchSubtaskData();
    }
  }, [selectedTask]);

  useEffect(() => {
    if (projectId && assigneeOptions) {
      fetchBacklogData(projectId);
    }
  }, [projectId, assigneeOptions]);

  useEffect(() => {
    if (!projectId) return;

    const filters = {
      assignee: selectedAssignee,
      epic: selectedEpic,
      label: selectedLabel,
      issue_type_id: selectedIssueTypeId,
    };

    if (hasFilters(filters)) {
      filterTask(filters);
    } else {
      // clear filtering mode
      setIsFiltering(false);

      setFilteredBacklog(backlogData);
      setFilteredSprints(sprints);
    }
  }, [
    projectId,
    selectedLabel,
    selectedAssignee,
    selectedEpic,
    selectedIssueTypeId,
    filterTask,
    backlogData,
    sprints,
  ]);

  const handleTaskClick = (task) => {
    setSelectedTask(task);
    setIsPanelOpen(true);

    //  setIsSubtaskModalOpen(true);
    //     setSelectedSubtask(task)
  };

  const handleClosePanel = async () => {
    setIsPanelOpen(false);
    setSelectedTask(null);
    setIsSubtaskModalOpen(false);
    setSelectedSubtask(null);
    await fetchBacklogData?.();
    // console.log('panel close');
  };

  useEffect(() => {
    if (projectId) {
      fetchMetadata(projectId);
      fetchUsers(projectId);
    }
  }, [projectId]);

  // const handleAssigneeClick = (user_id) => {
  //   setSelectedAssignee((prev) => {
  //     let updated;
  //     if (prev.includes(user_id)) {
  //       updated = prev.filter((id) => id !== user_id);
  //     } else {
  //       updated = [...prev, user_id];
  //     }

  //     // Apply or clear filter
  //     if (updated.length === 0) {
  //       fetchBacklogData();
  //     } else {
  //       filterTask({ assignee_ids: updated });
  //     }

  //     return updated;
  //   });
  // };

  const handleAssigneeClick = (user_id) => {
    setSelectedAssignee((prev) =>
      prev.includes(user_id)
        ? prev.filter((id) => id !== user_id)
        : [...prev, user_id],
    );
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        if (projectId) {
          setLoading(true);

          await Promise.all([fetchMetadata(projectId), fetchUsers(projectId)]);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [projectId]);

  const handleClear = () => {
    setSelectedAssignee([]);
    fetchBacklogData();
    // setAssigneeFilter(null);
    // setStatusFilter(null);
    // setLabelFilter(null);

    setFilteredBacklog([]);
    setFilteredSprints([]);

    setIsFiltering(false);
  };

  const visible = assigneeOptions.slice?.(0, MAX_VISIBLE);
  const hidden = assigneeOptions.slice?.(MAX_VISIBLE);

  // const overflowMenu = (
  //   <Menu>
  //     {hidden.map((a) => {
  //       const isSelected = selectedAssignee.includes(a.user_id);
  //       return (
  //         <Menu.Item
  //           key={a.user_id}
  //           onClick={() => handleAssigneeClick(a.user_id)}
  //           style={{
  //             background: isSelected ? '#f0f6ff' : 'transparent',
  //           }}
  //         >
  //           <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
  //             <UserAvatar username={a.username} size={24} />
  //             <span>{a.username}</span>
  //           </div>
  //         </Menu.Item>
  //       );
  //     })}
  //   </Menu>
  // );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCreateSprint = async (selectedTasks = []) => {
    try {
      const payload = {
        project_id: projectId,
        sprint_name: '',
        start_date: '',
        end_date: '',
        tasks: selectedTasks,
      };

      const response = await httpInjectorService.taskCreateSprint(payload);

      if (response.status === 'success') {
        toast.success(response.message || 'Sprint created successfully', {
          autoClose: 1000,
          position: 'top-right',
        });
        fetchBacklogData();
        await getsprintlist?.();
      } else {
        toast.error(response.message || 'Failed to create sprint.', {
          autoClose: 1500,
          position: 'top-right',
        });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const backlogToShow =
    displayedBacklog && displayedBacklog.length > 0
      ? displayedBacklog
      : backlogData;

  const sprintsToShow = displayedSprints;

  // const transformedBacklog = Array.isArray(backlogData)
  //   ? backlogData.map((task) => ({
  //       issue_type_id: task.issue_type_id,
  //       issue_type: task.issue_type,
  //       id: task.issue_id,
  //       key: task.issue_key,
  //       title: task.issue_title,
  //       type: task.task_type,
  //       status: task.issue_status || '+status',
  //       epic_id: task.epic_id,
  //       epic: task.epic,
  //       story_points: task.story_points ?? 0,
  //       labels:
  //         typeof task.labels === 'string'
  //           ? task.labels
  //               .split(',')
  //               .map((labelName) => {
  //                 const found = labelOptions.find(
  //                   (l) =>
  //                     l.label_name.toLowerCase() ===
  //                     labelName.trim().toLowerCase(),
  //                 );
  //                 return found || null;
  //               })
  //               .filter(Boolean)
  //           : Array.isArray(task.labels)
  //             ? task.labels
  //             : [],
  //       assignee_id: task.assignee_id || null,
  //       assignee: task.assignee,
  //       dueDate: task.dueDate || '',
  //       subtasks_count: {
  //         total: task.subtasks_count?.total ?? 0,
  //         done: task.subtasks_count?.done ?? 0,
  //       },
  //     }))
  //   : [];

  const filteredTransformedBacklog = isFiltering
    ? transformedBacklog.filter((issue) =>
        displayedBacklog.some((ft) => ft.issue_id === issue.id),
      )
    : transformedBacklog;

  const handleDeleteTask = async (issue) => {
    try {
      const payload = {
        issue_id: issue.issue_id || issue.id,
        issue_type_id: issue.issue_type_id,
        project_id: projectId,
      };

      const response = await httpInjectorService.deleteTask(payload);
      if (response.status === 'success') {
        toast.success('Issue deleted successfully');
        fetchBacklogData();
      } else {
        toast.error('Failed to delete Issue');
      }
    } catch (error) {
      console.error(error);
      toast.error('Error while deleting task');
    }
  };

  const handleAddTaskToSprint = async (sprintId, issue) => {
    try {
      const payload = {
        project_id: projectId,
        sprint_id: sprintId,
        issue_title: issue.issue_title,
        issue_type_id: issue.issue_type_id,
        issue_type: issue.issue_type,
        issue_status: issue.status || 'TO DO',
        assignee_id: issue.assignee_id || null,
      };

      const response = await httpInjectorService.addTaskToSprint(payload);

      if (response.status === 'success') {
        toast.success('Issue added successfully', {
          autoClose: 1000,
          position: 'top-right',
        });

        const newTask = {
          ...issue,
          id: response.data?.issue_id || Date.now(),
          key: response.data?.issue_key || Date.now(),
          title: '',
          status: issue.status || '+',
          type: '✔️ Task',
          epic: issue.epic_name || '+',
          story_points: 0,
          assignee: issue.assignee_id || '+',
          dueDate: issue.due_date
            ? dayjs(issue.due_date).format('DD MMM')
            : null,
        };

        setSprints((prev) =>
          prev.map((s) =>
            s.sprint_id === sprintId
              ? { ...s, tasks: [newTask, ...s.tasks] }
              : s,
          ),
        );

        fetchBacklogData();
      } else {
        toast.error(response.message || 'Failed to add task to sprint.', {
          autoClose: 1500,
          position: 'top-right',
        });
        setSprints([]);
        // dispatch(setsprintdata([]));
      }
    } catch (error) {
      console.error(error);
      toast.error('Error adding task to sprint');
      setSprints([]);
      //dispatch(setsprintdata([]));
    }
  };

  const handleUpdateTaskFromSprint = async (issue, sprintId) => {
    try {
      const existingSprint = sprints.find((s) => s.sprint_id === sprintId);
      const existingTask = existingSprint?.tasks?.find(
        (t) => t.id === issue.id || t.id === issue.issue_id,
      );

      const payload = {
        project_id: projectId,
        sprint_id: sprintId,
        issue_id: issue.issue_id || issue.id,
        issue_type_id: issue.issue_type_id || existingTask.issue_type_id,
        issue_title: issue.title || existingTask?.title || '',
        issue_status: issue.status || existingTask?.status || '',
        assignee_id:
          issue.assignee_id ??
          issue.assignee?.id ??
          existingTask?.assignee_id ??
          existingTask?.assignee?.id ??
          null,
        epic_id: issue.epic?.epic_id || issue.epic_id || existingTask?.epic_id,
        story_points: issue.story_points || existingTask?.story_points,
        due_date: issue.dueDate
          ? dayjs(issue.dueDate, ['DD MMM', 'YYYY-MM-DD']).format('YYYY-MM-DD')
          : existingTask?.dueDate
            ? dayjs(existingTask.dueDate, ['DD MMM', 'YYYY-MM-DD']).format(
                'YYYY-MM-DD',
              )
            : null,
        description: issue.description ?? existingTask?.description ?? '',
        work_item_url: `${window.location.origin}/admin/taskBoard/${projectId}/taskDetails/${issue.issue_id || issue.id}`,
      };

      const response = await httpInjectorService.updateTaskFromSprint(payload);
      if (response.status === 'success') {
        fetchBacklogData?.();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdateLabel = async (
    projectId,
    issue,
    sprintId,
    newLabelNames,
  ) => {
    // Get selected label objects
    const newLabels = labelOptions.filter((l) =>
      newLabelNames.includes(l.label_name),
    );

    // Optimistically update the task locally
    issue.labels = newLabels;

    // Trigger re-render
    // dispatch(setbacklogdata((prev) => [...prev]));
    setBacklogData((prev) => [...prev]);

    // Prepare payload for API
    const labelsId = newLabels.map((l) => l.label_id);
    const payload = {
      project_id: projectId,
      sprint_id: sprintId,
      issue_id: issue.issue_id || issue.id,
      issue_type_id: issue.issue_type_id,
      new_label_name: newLabelNames,
      labels_id: labelsId,
    };

    try {
      const response = await httpInjectorService.createLabel(payload);
      if (response.status !== 'success') {
        toast.error('Failed to update labels');
        fetchBacklogData(); // revert if API fails
      }
    } catch (error) {
      console.error(error);
      toast.error('Error updating labels');
      fetchBacklogData(); // revert if API fails
    }
  };

  const getsprintlist = async () => {
    try {
      let response = await httpInjectorService.getsprintList(projectId);

      if (response.status === 'success') {
        const activeSprints = (response.data?.active_sprints || []).filter(
          (sprint) => sprint.sprint_name?.toLowerCase() !== 'backlog',
        );

        const futureSprints = (response.data?.future_sprints || []).filter(
          (sprint) => sprint.sprint_name?.toLowerCase() !== 'backlog',
        );

        // Sprint list with backlog option
        const sprintOptions = [
          { label: 'Backlog', value: null },
          ...activeSprints.map((sprint) => ({
            label: sprint.sprint_name,
            value: sprint.sprint_id,
          })),
          ...futureSprints.map((sprint) => ({
            label: sprint.sprint_name,
            value: sprint.sprint_id,
          })),
        ];

        // Sprint list without backlog option (for backlog tasks)
        const backlogOptions = [
          ...activeSprints.map((sprint) => ({
            label: sprint.sprint_name,
            value: sprint.sprint_id,
          })),
          ...futureSprints.map((sprint) => ({
            label: sprint.sprint_name,
            value: sprint.sprint_id,
          })),
        ];

        setSprintList(sprintOptions); // used for tasks in sprint
        setSprintBacklogList(backlogOptions); // used for tasks in backlog
      } else {
        setSprintList([{ label: 'Backlog', value: null }]);
        setSprintBacklogList([]);
      }
    } catch (error) {
      console.error('Error fetching sprint list:', error);
      setSprintList([{ label: 'Backlog', value: null }]);
      setSprintBacklogList([]);
    }
  };

  const handleMoveTask = async (issue, sprintId) => {
    try {
      const payload = {
        issue_id: issue.issue_id || issue.id,
        issue_type_id: issue.issue_type_id,
        project_id: projectId,
        sprint_id: sprintId,
      };

      const response = await httpInjectorService.moveTaskToSprint(payload);

      if (response.status === 'success') {
        //toast.success(response.message);
        fetchBacklogData?.();
      } else {
        //toast.error(response.message);
      }
    } catch (error) {
      //toast.error(error.message);
    }
  };

  const reordeSprinttask = async (data) => {
    const response = await httpInjectorService.reorderTaskSprint(data);
    //console.log(response);
  };

  const taskToContainer = {};
  transformedBacklog.forEach((task) => {
    taskToContainer[task.key] = 'backlog';
  });

  (Array.isArray(sprints) ? sprints : []).forEach((sprint) => {
    sprint.tasks.forEach((task) => {
      taskToContainer[task.key] = sprint.sprint_id;
    });
  });

  const getTaskId = (task) => task.issue_id ?? task.id ?? task._id;

  const BACKLOG_ID = 'backlog';
  const sprintDroppableId = (id) => `sprint-${id}`;

  const findContainer = (id) => {
    if (id === BACKLOG_ID) return BACKLOG_ID;

    // if over a sprint container itself
    if (typeof id === 'string' && id.startsWith('sprint-')) {
      return id;
    }

    // check sprint tasks
    for (const sprint of sprints) {
      if (sprint.tasks?.some((t) => t.key === id)) {
        return sprintDroppableId(sprint.sprint_id);
      }
    }

    // backlog tasks
    if (filteredTransformedBacklog.some((t) => t.key === id)) {
      return BACKLOG_ID;
    }

    return null;
  };

  const getTaskByKey = (key) =>
    filteredTransformedBacklog.find((t) => t.key === key) ||
    sprints.flatMap((s) => s.tasks).find((t) => t.key === key);

  const sendReorderPayload = async (tasks) => {
    const payload = {
      project_id: projectId,
      issues: tasks.map((task, index) => ({
        issue_id: getTaskId(task),
        position: tasks.length - index, // inverted
      })),
    };

    await reordeSprinttask(payload);
  };

  const handleDragEnd = async ({ active, over }) => {
    if (!over) return;

    const activeId = active.id;
    const overId = over.id;

    const fromContainer = findContainer(activeId);
    const toContainer = findContainer(overId) ?? overId;

    if (!fromContainer || !toContainer) return;
    if (fromContainer === toContainer && activeId === overId) return;

    const movedTask = getTaskByKey(activeId);
    if (!movedTask) return;

    // =========================
    // 1️⃣ REORDER INSIDE SAME CONTAINER
    // =========================
    if (fromContainer === toContainer) {
      if (fromContainer === BACKLOG_ID) {
        setBacklogData((prev) => {
          const oldIndex = prev.findIndex((t) => t.key === activeId);
          let newIndex;
          if (overId === BACKLOG_ID) {
            newIndex = prev.length;
          } else {
            newIndex = prev.findIndex((t) => t.key === overId);
          }
          if (newIndex === -1 || oldIndex === -1) return prev;
          const updated = arrayMove(prev, oldIndex, newIndex);
          sendReorderPayload(updated);
          return updated;
        });
        return;
      }

      // Sprint reorder
      const sprintId = Number(fromContainer.replace('sprint-', ''));
      setSprints((prev) =>
        prev.map((s) => {
          if (s.sprint_id !== sprintId) return s;
          const oldIndex = s.tasks.findIndex((t) => t.key === activeId);
          let newIndex;
          if (overId === `sprint-${sprintId}`) {
            newIndex = s.tasks.length;
          } else {
            newIndex = s.tasks.findIndex((t) => t.key === overId);
          }
          if (newIndex === -1 || oldIndex === -1) return s;
          const updated = arrayMove(s.tasks, oldIndex, newIndex);
          sendReorderPayload(updated);
          return { ...s, tasks: updated };
        }),
      );
      return;
    }

    // =========================
    // 2️⃣ REMOVE FROM SOURCE
    // =========================
    if (fromContainer === BACKLOG_ID) {
      setBacklogData((prev) => prev.filter((t) => t.key !== activeId));
    } else {
      const sprintId = Number(fromContainer.replace('sprint-', ''));
      setSprints((prev) =>
        prev.map((s) =>
          s.sprint_id === sprintId
            ? { ...s, tasks: s.tasks.filter((t) => t.key !== activeId) }
            : s,
        ),
      );
    }

    // =========================
    // 3️⃣ ADD TO DESTINATION
    // =========================
    if (toContainer === BACKLOG_ID) {
      let insertIndex = 0;
      if (overId !== BACKLOG_ID) {
        const overIndex = backlogData.findIndex((t) => t.key === overId);
        if (overIndex !== -1) {
          insertIndex = overIndex + 1;
        }
      }
      setBacklogData((prev) => [
        ...prev.slice(0, insertIndex),
        movedTask,
        ...prev.slice(insertIndex),
      ]);
      await handleMoveTask(movedTask, null);
    } else {
      const sprintId = Number(toContainer.replace('sprint-', ''));
      const sprint = sprints.find((s) => s.sprint_id === sprintId);
      let insertIndex = 0;
      if (sprint && overId !== toContainer) {
        const overIndex = sprint.tasks.findIndex((t) => t.key === overId);
        if (overIndex !== -1) {
          insertIndex = overIndex + 1;
        }
      }
      setSprints((prev) =>
        prev.map((s) =>
          s.sprint_id === sprintId
            ? {
                ...s,
                tasks: [
                  ...s.tasks.slice(0, insertIndex),
                  movedTask,
                  ...s.tasks.slice(insertIndex),
                ],
              }
            : s,
        ),
      );
      await handleMoveTask(movedTask, sprintId);
    }
  };

  useEffect(() => {
    getsprintlist();
  }, []);

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: '175px',
          left: '50px',
          right: 0,
          bottom: 0,
          background: '#fff',
          overflow: 'hidden',
        }}
      >
        <Split
          className="split-layout"
          sizes={isPanelOpen ? [60, 40] : [100, 0]}
          minSize={[800, 0]}
          gutterSize={6}
          snapOffset={50}
          expandToMin={false}
          cursor="col-resize"
          gutter={(index, direction) => {
            const gutter = document.createElement('div');
            gutter.className = `gutter gutter-${direction}`;

            gutter.addEventListener('mousedown', () => {
              gutter.classList.add('dragging');
            });
            window.addEventListener('mouseup', () => {
              gutter.classList.remove('dragging');
            });

            return gutter;
          }}
          style={{ height: '100%', display: 'flex' }}
        >
          {/* LEFT SIDE — BACKLOG CONTENT */}
          <div
            style={{
              background: '#fff',
              transition: 'width 0.3s ease',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
            
          >
            <div style={{ flex: 1, overflowY: 'auto' }}  >
              <Card
                style={{
                  border: 'none',
                  paddingLeft: '40px',
                  paddingRight: '30px',
                  paddingBottom: '20px',
                  background: '#fff',
                }}
              >
                {/* Filters */}
                <div
                  className="mt-2"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '8px 16px',
                    borderBottom: '1px solid #f0f0f0',
                    background: '#fff',
                    position: 'sticky',
                    top: 0,
                    zIndex: 20,
                  }}
                  data-tour="backlog-filters"
                  
                >
                  <Input
                    prefix={<AiOutlineSearch />}
                    placeholder="Search backlog..."
                    style={{ width: '200px' }}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    allowClear
                    data-tour="backlog-search"
                  />

                  <Space style={{ position: 'relative', display: 'flex' }}>
                    {visible.map((a, index) => {
                      const isSelected = selectedAssignee.includes(a.user_id);
                      return (
                        <Tooltip key={a.user_id} title={a.username}>
                          <div
                            onClick={() => handleAssigneeClick(a.user_id)}
                            style={{
                              border: isSelected
                                ? '2px solid #1677ff'
                                : '2px solid white',
                              borderRadius: '50%',
                              boxShadow: isSelected
                                ? '0 0 5px rgba(22,119,255,0.4)'
                                : 'none',
                              marginLeft: index === 0 ? 0 : -8,
                              cursor: 'pointer',
                              transition: '0.2s',
                              background: '#fff',
                            }}
                          >
                            <UserAvatar username={a.username} size={32} />
                          </div>
                        </Tooltip>
                      );
                    })}

                    {hidden.length > 0 && (
                      <div
                        ref={dropdownRef}
                        style={{
                          position: 'relative',
                          display: 'inline-block',
                        }}
                      >
                        <div
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            background: '#f5f5f5',
                            color: '#555',
                            fontSize: 13,
                            fontWeight: 500,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: -8,
                            cursor: 'pointer',
                            border: '2px solid white',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setDropdownOpen((prev) => !prev);
                          }}
                        >
                          +{hidden.length}
                        </div>

                        {/* Custom popup menu */}
                        {dropdownOpen && (
                          <div
                            style={{
                              position: 'absolute',
                              top: 40,
                              right: 0,
                              width: 220,
                              maxHeight: 300,
                              overflowY: 'auto',
                              background: '#fff',
                              border: '1px solid #f0f0f0',
                              borderRadius: 8,
                              padding: 8,
                              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                              zIndex: 1200,
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {hidden.map((a) => {
                              const isSelected = selectedAssignee.includes(
                                a.user_id,
                              );
                              return (
                                <div
                                  key={a.user_id}
                                  onClick={() => handleAssigneeClick(a.user_id)}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '8px',
                                    borderRadius: 6,
                                    background: isSelected
                                      ? 'rgba(22,119,255,0.08)'
                                      : 'transparent',
                                    cursor: 'pointer',
                                    marginBottom: 6,
                                  }}
                                >
                                  <UserAvatar username={a.username} size={24} />
                                  <span style={{ flex: 1, fontSize: 13 }}>
                                    {a.username}
                                  </span>
                                  {isSelected && (
                                    <span
                                      style={{
                                        color: '#1677ff',
                                        fontWeight: 700,
                                      }}
                                    >
                                      ✓
                                    </span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </Space>

                  {selectedAssignee.length > 0 && (
                    <span
                      onClick={handleClear}
                      style={{
                        cursor: 'pointer',
                        color: '#1677ff',
                        fontSize: 13,
                        marginLeft: 8,
                        textDecoration: 'underline',
                      }}
                    >
                      Clear
                    </span>
                  )}

                  <Select
                    mode="multiple"
                    allowClear
                    onClear={handleClear}
                    placeholder="Filter by Epic"
                    style={{ width: 180 }}
                    options={epicOptions.map((e) => ({
                      label: e.epic_name,
                      value: e.epic_id,
                    }))}
                    value={selectedEpic}
                    onChange={(val) => setSelectedEpic(val)}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />

                  {/* <Select
                    mode="multiple"
                    allowClear
                    onClear={handleClear}
                    placeholder="Filter by Label"
                    style={{ width: 180 }}
                    options={labelOptions.map((l) => ({
                      label: l.label_name,
                      value: l.label_id,
                    }))}
                    value={selectedLabel}
                    onChange={(val) => setSelectedLabel(val)}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  /> */}

                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Filter by Issue Type"
                    style={{ width: 180 }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={selectedIssueTypeId}
                    onChange={(val) => setSelectedIssueTypeId(val)}
                  >
                    <Option value="1">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6,
                        }}
                      >
                        <TaskObject width={20} stroke="#0052CC" />
                        <span>Task</span>
                      </div>
                    </Option>

                    <Option value="2">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6,
                        }}
                      >
                        <StoryObject width={20} stroke="#36B37E" />
                        <span>Story</span>
                      </div>
                    </Option>

                    <Option value="3">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6,
                        }}
                      >
                        <BugObject width={20} stroke="#172B4D" />
                        <span>Bug</span>
                      </div>
                    </Option>
                  </Select>
                </div>

                {/* Main Content */}
                {loading ? (
                  <Flex
                    justify="center"
                    align="center"
                    w="100%"
                    h="300px"
                    mt="55px"
                    data-tour="backlog-list"
                  >
                    <SkeletonWithLoaders />
                  </Flex>
                ) : (
                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                  >
                    <div style={{ marginTop: 24 }} data-tour="backlog-list">
                      {sprintsToShow.map((sprint) => (
                        <DroppableContainer
                          key={sprint.sprint_id}
                          id={sprintDroppableId(sprint.sprint_id)}
                        >
                          <SortableContext
                            items={(sprint.tasks || []).map((t) => t.key)}
                            strategy={verticalListSortingStrategy}
                          >
                            <SprintListSection
                              sprint={sprint}
                              selectedKeys={selectedKeys}
                              setSelectedKeys={setSelectedKeys}
                              handleTaskClick={handleTaskClick}
                              sprints={sprintsToShow}
                              setSprints={setSprints}
                              projectId={projectId}
                              handleAddTaskToSprint={handleAddTaskToSprint}
                              selectedSprintKeys={selectedSprintKeys}
                              setSelectedSprintKeys={setSelectedSprintKeys}
                              //BulkActionBar={BulkActionBar}
                              fetchBacklogData={fetchBacklogData}
                              handleUpdateTaskFromSprint={
                                handleUpdateTaskFromSprint
                              }
                              handleDeleteTask={handleDeleteTask}
                              sprintList={sprintList}
                              sprintBacklogList={sprintBacklogList}
                              handleMoveTask={handleMoveTask}
                              epicOptions={epicOptions}
                              statusOptions={statusOptions}
                              assigneeOptions={assigneeOptions}
                              labelOptions={labelOptions}
                              getsprintlist={getsprintlist}
                              handleUpdateLabel={handleUpdateLabel}
                              sprintCounts={sprintCounts}
                              selectedTask={selectedTask}
                            />
                          </SortableContext>
                        </DroppableContainer>
                      ))}
                      <DroppableContainer id={BACKLOG_ID}>
                        <SortableContext
                          items={filteredTransformedBacklog.map((t) => t.key)}
                          strategy={verticalListSortingStrategy}
                        >
                          <Backlog
                            //backlogData={backlogToShow}
                            collapsed={collapsed}
                            setCollapsed={setCollapsed}
                            handleCreateSprint={handleCreateSprint}
                            createdTasks={filteredTransformedBacklog}
                            fetchBacklogData={fetchBacklogData}
                            projectId={projectId}
                            handleDeleteTask={handleDeleteTask}
                            sprintList={sprintBacklogList}
                            handleMoveTask={handleMoveTask}
                            //  sprintBacklogList={sprintBacklogList}
                            epicOptions={epicOptions}
                            statusOptions={statusOptions}
                            assigneeOptions={assigneeOptions}
                            labelOptions={labelOptions}
                            handleUpdateLabel={handleUpdateLabel}
                            handleTaskClick={handleTaskClick}
                            backlogCounts={backlogCounts}
                          />
                        </SortableContext>
                      </DroppableContainer>
                    </div>
                  </DndContext>
                )}
              </Card>
            </div>
          </div>
          {/* RIGHT SIDE — TASK DETAIL PANEL */}
          <div
            style={{
              overflowY: 'auto',
              borderLeft: '1px solid #f0f0f0',
              background: '#fff',
              padding: '16px',
              transition: 'width 0.3s ease',
              width: '80%',
            }}
          >
            {/* PRIORITY 1: SUBTASK PANEL */}
            {isSubtaskModalOpen && selectedSubtask ? (
              <SubtaskDetailModal
                projectId={projectId}
                isSubtaskModalOpen={isSubtaskModalOpen}
                setIsSubtaskModalOpen={setIsSubtaskModalOpen}
                setSelectedSubtask={setSelectedSubtask}
                selectedSubtask={selectedSubtask}
                subtasks={subTasks}
                // onClose={() => {
                //   setIsSubtaskModalOpen(false);
                //   setSelectedSubtask(null);
                // }}
                onClose={handleClosePanel}
                subtaskDetails={subtaskDetails}
                setSubtaskDetails={setSubtaskDetails}
                selectedTask={selectedTask}
                getSubTaskDetails={getSubTaskDetails}
                fetchSubtaskData={fetchSubtaskData}
              />
            ) : null}

            {/* PRIORITY 2: TASK PANEL */}
            {!isSubtaskModalOpen && isPanelOpen && selectedTask ? (
              <TaskDetailPanel
                selectedTask={selectedTask}
                isPanelOpen={isPanelOpen}
                onClose={handleClosePanel}
                fetchBacklogData={fetchBacklogData}
                isSubtaskModalOpen={isSubtaskModalOpen}
                setIsSubtaskModalOpen={setIsSubtaskModalOpen}
                setSelectedSubtask={setSelectedSubtask}
                selectedSubtask={selectedSubtask}
                subtaskDetails={subtaskDetails}
                //handleSubtaskClick={handleSubtaskClick}
              />
            ) : null}
          </div>
        </Split>
      </div>
    </>
  );
};

export default BacklogPage;
